export enum ModalType {
  Error = 1,
  Warning = 2,
  Info = 3,
  Default = 4
}
